import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SeparatorWithWord = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    margin: 1.33rem 0;
    position: relative;
    width: 100%;
    ::before {
        content: '';
        display: block;
        background-color: #cccccc;
        position: absolute;
        top: 50%;
        height: 1px;
        width: 85%;
    }
    span {
        background-color: #ffffff;
        padding: 0 1.33rem;
        z-index: 1;
    }
`;

const ExternalReferenceWorkflowStepOne = ({
    generateSpecificationOptions,
    loading,
    setRenderStep,
    defaultAddNew,
    resourceName,
    resourceNameShort,
    ...props
}) => {
    return (
        <div className="modal-content">
            <div className="modal-header">
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 className="modal-title">
                    <span id="ext-links-references-add-page-title">
                        Add {resourceName}
                    </span>
                </h4>
            </div>
            <div
                className="modal-body align-center"
                style={{ padding: '1.66rem 0' }}
            >
                <button
                    className="btn btn-primary"
                    id="workflow-to-add-new"
                    onClick={defaultAddNew}
                >
                    Add New {resourceName}
                </button>
                <SeparatorWithWord>
                    <span>OR</span>
                </SeparatorWithWord>
                <button
                    disabled={loading}
                    className="btn btn-default"
                    id="import-existing-reference-nodismiss"
                    onClick={() =>
                        generateSpecificationOptions().then(() =>
                            setRenderStep(2)
                        )
                    }
                >
                    {loading
                        ? `Loading Specifications...`
                        : `Import an Existing ${resourceNameShort}`}
                </button>
            </div>
        </div>
    );
};

ExternalReferenceWorkflowStepOne.propTypes = {
    generateSpecificationOptions: PropTypes.func,
    loading: PropTypes.bool,
    setRenderStep: PropTypes.func,
    resourceName: PropTypes.string
};

ExternalReferenceWorkflowStepOne.defaultProps = {
    generateSpecificationOptions: () => null,
    loading: false,
    setRenderStep: () => null
};

export default ExternalReferenceWorkflowStepOne;
